import { render, staticRenderFns } from "./YwArtificialPatrolPointList.vue?vue&type=template&id=5e8e869c&scoped=true&"
import script from "./YwArtificialPatrolPointList.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolPointList.vue?vue&type=script&lang=js&"
import style0 from "./YwArtificialPatrolPointList.vue?vue&type=style&index=0&id=5e8e869c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e869c",
  null
  
)

export default component.exports